import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import InstructionsWeb from "./layouts/Instructions.web";
import InstructionsMob from "./layouts/Instructions.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { FC, useState } from "react";
import { HOW_TO_USE_KEY } from "../../constants";

const InstructionsComponent = withConditionalComponent(InstructionsWeb, InstructionsMob);

type Props = {
  usageInstructions: string;
  termsAndConditions: string;
};

const Instructions: FC<Props> = ({ usageInstructions, termsAndConditions }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [activeKey, setActiveKey] = useState(HOW_TO_USE_KEY);

  return (
    <InstructionsComponent
      trigger={isLargeScreen}
      props={{
        usageInstructions, termsAndConditions
      }}
      componentAProps={{
        activeKey,
        onChange: (key: string) => setActiveKey(key),
      }}
    />
  );
};

export default Instructions;
